import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name AimerPay Default Settings
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#0abf53', // Adyen green
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'AimerPay',
  pwa: false,
  logo: '/logo.svg',
  iconfontUrl: '',
  token: {},
  siderMenuType: 'group',
  splitMenus: false,
};

export default Settings;
